export const cancelSteps = {
    taste: ["feedback", "price_off"],
    medical: ["feedback", "price_off"],
    shippingIssue: ["choose", "price_off"],
    other: ["feedback", "price_off"],
    trial: ["skip_next_order", "price_off"],
    price: ["choose", "price_off"],
    lessExercise: ["why_reason", "new_goal"],
    tooMuch: ["choose", "price_off"],
    before_arrive: ["skip_next_order", "price_off"],
    cancel_2nd: ["choose"],
    already_cancelled: ["choose"],
    already_cancelled_shipping_issue: ["choose"],
    already_filed_complaint: ["choose"],
    target: ["choose"],
};
export const workingOutLessSteps = {
    completed_event: ["price_off", "feedback"],
    injury: ["price_off"],
    completed_goal: ["price_off", "feedback"],
    pausing_for_some_time: ["choose"],
};
export const flexibiltyOptions = [
    {
        label: "",
        value: "",
    },
];
export const reasons = [
    {
        label: "I HAVE TOO MUCH PRODUCT RIGHT NOW",
        value: "tooMuch",
    },
    {
        label: "It’s too expensive",
        value: "price",
    },
    {
        label: "I don’t like the taste",
        value: "taste",
    },
    {
        label: "MEDICAL/DIGESTION",
        value: "medical",
    },
    {
        label: "Shipping Issue",
        value: "shippingIssue",
    },
    {
        label: "I JUST WANTED TO TRY IT",
        value: "trial",
    },
    {
        label: "I AM WORKING OUT LESS",
        value: "lessExercise",
    },
    {
        label: "Easier to buy at Target",
        value: "target",
    },
    {
        label: "Other",
        value: "other",
    },
];
// common
const continueToCancel = "Continue to cancel";
const cancelSubscription = "CANCEL SUBSCRIPTION";
const mainBtn10off = "claim 10% off";
const keepPointsClaim10 = "Keep points & claim 10% off";
const continueText = "Continue";
const text10off = (isOther) => `Thank you for your feedback. Your message has been sent to ${isOther ? "our Support Team" : "your Registered Dietitian"} and you will hear back within 1 business day.<br/> <br/> In the meantime, here’s 10% off your next order. Claim below, code automatically applied to your subscription.`;
const stayAndClaim100Points = "STAY & CLAIM 100 POINTS";
const confirmSkip = "Confirm Skip";
const skipNextOrder = "SKIP YOUR NEXT ORDER";
const claim200 = "CLAIM 200 POINTS";
const stayAndClaim200 = "SET MY GOALS & Get 200 points";
const setGoalsAndClaim200 = "SET MY GOALS & Get 200 points";
const get50offProtein = "Get 50% off Protein + Collagen";
const keepPoinstAnd50 = "Keep points & claim 50% off";
const keepAndClaim20off = "Keep points & claim 20% off ";
//  taste reason
const feedbackRDHeadline = "Let’s make it taste better.";
const feedbackRdText = "If you are unhappy with your blend, your Registered Dietitian will work with you to reformulate your blend and replace it for free. Send a message to your RD below and they will reach out via email to within 1 business day.";
const headline10off = "Here’s 10% on us.";
const stayWithUsHeadline = "Stay with us to save your points.";
const stayWithUsText = (points, amount, discountOffer) => `We appreciate your loyalty. You have ${points} points in your account to be redeemed ${points > 100 ? `for ${amount}` : ""} off future orders. Stay a subscriber to keep your points, plus <b>${discountOffer}</b><br/><br/><b>*If you cancel, you will lose ALL points* </b>`;
const stayAndGet20 = "Stay & Get 20% off next 2 orders";
// shipping reason
const shippingChooseHeadline = "We're so sorry to hear that.";
const shippingChooseText = "Our team is dedicated to providing you with a stress-free experience. Please provide details about your shipping issue and a member of our team will reach out via email to help.";
const shippingChooseOptions = [
    {
        label: "My order was delayed",
        value: "My order was delayed",
    },
    {
        label: "My order never arrived",
        value: "My order never arrived",
    },
    {
        label: "My order arrived damaged",
        value: "My order arrived damaged",
    },
    {
        label: "My order arrived incomplete",
        value: "My order arrived incomplete",
    },
];
const shipping10offText = "Thank you for your feedback. Your message has been sent to our Support Team and you will hear back within 1 business day.<br/> <br/>To make up for the inconvenience, we'd like to offer you 10% off your next order. This will be automatically applied to your account.";
// medical reason
const medicalRdHeadline = "We’re here to meet your needs.";
const medicalRdText = "If you had any issues with your Gainful products, your Registered Dietitian will work with you to reformulate your blend and replace it for free. Please briefly explain your issue and your Registered Dietitian will reach out via email within 1 business day.";
// too much reason
const tooMuchChooseHeadline = "Need more time?";
const tooMuchChooseText = "Want to take a break from Gainful? Delay your next order to give you more time to finish your products. Select a skip period below and we will send you a reminder email a few days before your next order is placed. ";
const tooMuchChooseOptions = [
    {
        label: "Skip 4 Weeks",
        value: 4,
    },
    {
        label: "Skip 6 weeks",
        value: 6,
    },
    {
        label: "Skip 8 weeks",
        value: 8,
    },
];
const tooMuchPointsText = (points, amount) => `We appreciate your loyalty. You have ${points} points in your account to be redeemed ${points > 100 ? `for ${amount}` : ""} off future orders. Stay a subscriber to claim an additional 100 points (worth $5 off).<br> <b>*If you cancel, you will lose ALL points* </b>`;
const tooExpensiveChooseHeadline = "Need more flexibility?";
const tooExpensiveChooseText = "Update your delivery frequency to recieve Gainful shipments on a cadence that works best for you.";
const tooExpensiveOptions = [
    {
        label: "3 Weeks",
        value: 3,
    },
    {
        label: "4 Weeks",
        value: 4,
    },
    {
        label: "6 Weeks",
        value: 6,
    },
    {
        label: "8 Weeks",
        value: 8,
    },
    {
        label: "12 Weeks",
        value: 12,
    },
];
// trial
const trialSkipText = "We get it, life gets busy. Click below <b>Skip your next order</b> to give yourself more time to try your personalized system. ";
const trialSkipHeadline = "Need a break?";
// working out less
const workingOutHeadline = "Why are you exercising less?";
const workingOutLessButtons = [
    {
        label: "I completed an event I was training for",
        value: "completed_event",
    },
    {
        label: "I am injured",
        value: "injury",
    },
    {
        label: "I reached my goal",
        value: "completed_goal",
    },
    {
        label: "i am pausing training for some time",
        value: "pausing_for_some_time",
    },
];
const completedPointsHeadline = "Here’s 200 points on us";
const completedPointsText = "Congratulations! Here is 200 extra points from the Gainful rewards program to celebrate your win! Click below to claim your points.";
const completedFeedbackHeadline = "Time for a new goal.";
const completedFeedbackText = " Now that you’ve completed your event, you can start setting new goals with your Gainful Registered Dietitian. Enter your thoughts below and an RD will reach out within 1 business day with a personalzied plan for what comes next.<br/>Plus, get 200 points added to your account when you stay.";
const completedLosePoints = (points, amount) => `By canceling, you acknowledge you will lose ${points} points from the Gainful reward program, worth ${amount} dollars off your next order. <br/>Plus, get 200 points if you stay subscribed.`;
//
const otherFeedbackText = "If you had any issues with your Gainful products, our support team is here to help. Please briefly explain your issue and our team will reach out via email within 1 business day.";
// reasons
const reasonBuildMuscleHeadline = "Building muscle takes time.";
const reasonBuildMuscleText = (discountOffer) => `It’s important to remain consistent with your nutrition and exercise routines to increase muscle mass and feel stronger. <br/><b>${discountOffer}</b> to find your stride and reach your goals. Click below to claim your discount.`;
const reasonLoseWeightHeadline = "Losing weight takes time.";
const reasonLoseWeightText = (discountOffer) => `It’s important to remain consistent with your nutrition and exercise routines to hit your weight loss goal.<br> <b>${discountOffer}</b> to find your stride and reach your goals. Click below to claim your discount.`;
const reachGoalHeadline = "Reaching your goals takes time.";
const reachGoalText = (discountOffer) => `It’s crucial to remain consistent with your nutrition and exercise habits to hit your goals. <br/> <b>${discountOffer}</b> to stay consistent. Click below to claim your discount.`;
// injury
const injuredPriceOffHeadline = "Recovery is crucial.";
const injuredPriceOffText = "Did you know protein and collagen are key supplements that support faster recovery after an injury? Get back on track with <b>50% off your next order of Gainful Personalized Protein Collagen<b/>. Claim discount below. ";
// pause
const pauseChooseHeadline = "Time for a break?";
const pauseChooseText = "We understand training is a cycle. We will be here for you when you are ready to jump back in. We can pause your subscription until you are ready to come back. We will reach out before your subscription becomes active again.";
const pauseChooseOptions = [
    {
        label: "Pause 1 Month",
        value: 1,
    },
    {
        label: "Pause 2 Months",
        value: 2,
    },
    {
        label: "Pause 3 Months",
        value: 3,
    },
    {
        label: "Pause 4 Months",
        value: 4,
    },
    {
        label: "Pause 5 Months",
        value: 5,
    },
];
const beforeArrivesSkipHeadline = "The best is yet to come!";
const beforeArrivesSkipText = `Your order is about to arrive, and we think you will love it. If you don’t, we’ll work to make it better for you.
<br/>Not ready to commit to a subscription? Skip your next order to give yourself more time to try your personalized system. `;
const stayAndKeepPoints = "Stay & KEEP POINTS";
const stayAndKeepPointsText = (points, amount) => `By canceling, you acknowledge you will lose ${points} points from the Gainful reward program, worth ${amount} dollars off your next order. Do you still wish to cancel? Stay subscribed to keep your points.`;
export const getInfoForReason = (reason, step, goals, workingOutLessReason = "", workingOutLessStep = "", discountOffer = "", discountOfferBtn = "") => {
    const isTaste = reason === "taste";
    const isMedical = reason === "medical";
    const isTooMuch = reason === "tooMuch";
    const isTooExpensive = reason === "price";
    const isShipping = reason === "shippingIssue";
    const isTrial = reason === "trial";
    const isWorkingOutLess = reason === "lessExercise";
    const isOther = reason === "other";
    const isBeforeArrives = reason === "before_arrive";
    const isCancel2nd = reason === "cancel_2nd";
    const isAlreadyCancelled = reason === "already_cancelled";
    const isAlreadyCancelledShippingIssue = reason === "already_cancelled_shipping_issue";
    const isTarget = reason === "target";
    const isAlreadyFiledComplaint = reason === "already_filed_complaint";
    if (isWorkingOutLess) {
        const isCompleted = workingOutLessReason === "completed_event";
        const isInjured = workingOutLessReason === "injury";
        const isReached = workingOutLessReason === "completed_goal";
        const isPause = workingOutLessReason === "pausing_for_some_time";
        if (!workingOutLessReason) {
            return {
                buttonsOptions: workingOutLessButtons,
                headline: workingOutHeadline,
            };
        }
        if (isCompleted || isReached || isInjured || isPause) {
            if (workingOutLessStep === "price_off") {
                return {
                    headline: isInjured ? injuredPriceOffHeadline : completedPointsHeadline,
                    text: () => (isInjured ? injuredPriceOffText : completedPointsText),
                    mainBtnText: isInjured ? get50offProtein : claim200,
                    secondaryBtnText: continueToCancel,
                };
            }
            if (workingOutLessStep === "feedback") {
                return {
                    headline: completedFeedbackHeadline,
                    text: () => completedFeedbackText,
                    mainBtnText: setGoalsAndClaim200,
                    secondaryBtnText: continueToCancel,
                };
            }
            if (workingOutLessStep === "choose") {
                return {
                    headline: pauseChooseHeadline,
                    text: () => pauseChooseText,
                    radioOptions: pauseChooseOptions,
                    mainBtnText: "PAUSE SUBSCRIPTION",
                    secondaryBtnText: continueToCancel,
                };
            }
        }
    }
    if (isTooMuch) {
        if (step === "choose") {
            return {
                headline: tooMuchChooseHeadline,
                text: () => tooMuchChooseText,
                radioOptions: tooMuchChooseOptions,
                mainBtnText: confirmSkip,
                secondaryBtnText: continueToCancel,
            };
        }
        if (step === "price_off") {
            return {
                headline: reasonLoseWeightHeadline,
                text: () => reasonLoseWeightText(discountOffer),
                mainBtnText: discountOfferBtn,
                secondaryBtnText: cancelSubscription,
            };
        }
    }
    if (isBeforeArrives ||
        isCancel2nd ||
        isAlreadyCancelled ||
        isTooExpensive ||
        isTrial ||
        isTarget ||
        isAlreadyFiledComplaint) {
        if (step === "choose") {
            return {
                headline: tooExpensiveChooseHeadline,
                text: () => tooExpensiveChooseText,
                radioOptions: tooExpensiveOptions,
                mainBtnText: "UPDATE FREQUENCY",
                secondaryBtnText: continueToCancel,
            };
        }
        if (step === "skip_next_order") {
            let headline = "";
            let text = "";
            if (isTrial || isTooExpensive) {
                headline = trialSkipHeadline;
                text = trialSkipText;
            }
            if (isBeforeArrives) {
                headline = beforeArrivesSkipHeadline;
                text = beforeArrivesSkipText;
            }
            return {
                headline,
                text: () => text,
                mainBtnText: skipNextOrder,
                secondaryBtnText: continueToCancel,
            };
        }
        if (step === "price_off") {
            let headline = reachGoalHeadline;
            let text = () => reachGoalText(discountOffer);
            if (goals?.includes("Lose Weight")) {
                headline = reasonLoseWeightHeadline;
                text = () => reasonLoseWeightText(discountOffer);
            }
            if (goals?.includes("Build Muscle")) {
                headline = reasonBuildMuscleHeadline;
                text = () => reasonBuildMuscleText(discountOffer);
            }
            return {
                headline,
                text: () => text(),
                mainBtnText: discountOfferBtn,
                secondaryBtnText: continueToCancel,
            };
        }
    }
    if (isAlreadyCancelledShippingIssue || isTaste || isMedical || isShipping || isOther) {
        if (step === "feedback") {
            return {
                headline: isTaste ? feedbackRDHeadline : medicalRdHeadline,
                text: () => {
                    if (isTaste) {
                        return feedbackRdText;
                    }
                    if (isMedical) {
                        return medicalRdText;
                    }
                    return otherFeedbackText;
                },
                mainBtnText: continueText,
            };
        }
        if (step === "choose") {
            return {
                headline: shippingChooseHeadline,
                text: () => shippingChooseText,
                radioOptions: shippingChooseOptions,
                mainBtnText: continueText,
            };
        }
        if (step === "price_off") {
            return {
                headline: headline10off,
                text: () => (isShipping ? shipping10offText : text10off(isOther)),
                mainBtnText: mainBtn10off,
                secondaryBtnText: continueToCancel,
            };
        }
    }
    return {
        headline: "",
        text: () => "",
        mainBtnText: "",
        secondaryBtnText: "",
    };
};
const getStepForPayload = (reason, step, workingOutLessReason, workingOutLessStep) => {
    const cancel2nd = reason === "cancel_2nd";
    const alreadyCancelled = reason === "already_cancelled";
    if (step === "feedback") {
        if (["taste", "medical"].includes(reason)) {
            return "submit_feedback_RD";
        }
        if (reason === "shippingIssue") {
            return "submit_feedback_shipping";
        }
        return "submit_feedback_cx";
    }
    if (step === "price_off") {
        return "redeem_coupon";
    }
    if (step === "choose") {
        if (reason === "tooMuch") {
            return "skip_next_order";
        }
        if (reason === "shippingIssue") {
            return "submit_feedback_cx";
        }
        return "adjust_frequency";
    }
    if (workingOutLessReason === "injury") {
        return "redeem_coupon";
    }
    if (workingOutLessReason === "pausing_for_some_time" && workingOutLessStep === "choose") {
        return "pausing_for_some_time";
    }
    return step;
};
export const buildPayload = (reason, step, workingOutLessReason, workingOutLessStep) => {
    const updatedStep = getStepForPayload(reason, step, workingOutLessReason, workingOutLessStep);
    return {
        reason,
        step: updatedStep,
        working_out_less_reason: workingOutLessReason,
    };
};
